/** Libraries a tool implementation may import; anything else fails at bundle time. */
export const TOOL_ALLOWED_IMPORTS = ["zod", "date-fns", "axios", "nanoid"] as const;

/** Tool names are passed to the provider as function names. */
export const TOOL_NAME_PATTERN = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

export const TOOL_NAME_MAX_LENGTH = 64;

export const DEFAULT_TOOL_INPUT_SCHEMA = JSON.stringify(
  {
    type: "object",
    properties: {},
    required: [],
    additionalProperties: false,
  },
  null,
  2,
);

export const DEFAULT_TOOL_CODE = `export default async function execute(input, { toolCallId, messages }) {
  return { ok: true };
}
`;

/**
 * What the log shows for a call cut off before it returned: the run was
 * stopped, failed or lost its connection. Shown the same live (`ToolCallLog`)
 * and after a reload, where a chat stores the call as `interrupted` and gets it
 * back as an `output-error` with this message (`chats/helpers/toolParts.ts`).
 * Worded to hold either way: a call can be cut off while its arguments are
 * still being written (the tool never ran) or while the tool runs.
 */
export const INTERRUPTED_TOOL_MESSAGE =
  "Stopped before the tool returned. It may not have run, or may have run only in part.";

/**
 * Sidebar selection sentinel for the hosted-function pane.
 *
 * Selection is shared with the JSON Schema engine's reducer, so a plain node id
 * selects a property, `ROOT_NODE_ID` selects the Tool details pane (whose
 * "Input schema" list and "Allow additional properties" toggle *are* the schema
 * root), and this sentinel selects the function editor. The reducer ignores ids
 * it doesn't know, which is exactly the behaviour needed here.
 */
export const HOSTED_FUNCTION_ID = "hosted-function";
